import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      Plejmulto de animaloj havas la cerbon kaj la koron en la sama nivelo; kaj la nivelo tia, ni devas agnoski, ne estas tro alta. 
      Ja kia alteco povas esti en horizontala stato!
    </p>
    
    <p class="mb-3">
      La Homo, stariĝine vertikale, signife altigis tiun ĝeneralan nivelon; sed lia cerbo troviĝas ekde tiam pli alte, ol la koro.
    </p>

    <p class="mb-3">
      La cerbo de Homo situas signife pli alte, ol la koro, kaj la distanco inter ili fariĝas ju pli granda, des pli alten atingas Homo.
    </p>
  `
  )
}

const itemName = {
  esp: 'La vertikalo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;